import { SVGProps } from 'react';



function BubbleRevertedIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 786.521 791.612"
            width="0.993em"
            height="1em"
            {...props}
        >
            <path
                d="M97.921 66.828c-53.993 84.613 56.04 170.045 37.04 300.372s-195.78 117.61-113.04 220.937 254.11 244.225 444 192.372 284.8-262.06 315.558-399.774-84.883-63.084-192.52-151.081S447.187 60.662 350.931 28.749C228.172-11.958 151.914-17.785 97.921 66.828z"
                fill="#1688f3"
                opacity={0.05}
            />
        </svg>
    );
}

export default BubbleRevertedIcon;
